<app-breadcrumb></app-breadcrumb>
<div class="card mb-0">
    <div class="card-body">
        <dtg-manage-driver-list [listType]="DtgListType.list"></dtg-manage-driver-list>
    </div>
</div>